import * as React from 'react';
import { Suspense } from 'react';
import { Location } from 'history';
import { RouteComponentProps } from 'react-router';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import { LOGIN_ROUTES, PUBLIC_SESSION_ROUTES } from 'src/routing';
import IRouteConfig from 'src/routing/IRouteConfig';
import ROUTE_PATHS from 'src/routing/paths';
import LoadingOverlay from 'src/components/LoadingOverlay/LoadingOverlay';

export interface IRootProps {
  from: Location;
}

class Root extends React.Component<IRootProps & RouteComponentProps<any>> {

  public render() {

    const unauthorizedRoutes: IRouteConfig[] = LOGIN_ROUTES.concat(PUBLIC_SESSION_ROUTES);
    const publicRoutes = unauthorizedRoutes.map((routeConfig: IRouteConfig, index) => {
      if (!routeConfig.routeProps.component) {
        return null;
      }
      return <Route key={index} {...routeConfig.routeProps}/>;
    });
    
    return (
      <Suspense fallback={<LoadingOverlay isFallback={true} active={true} spinner={true}/>}>
        <Switch>
          {publicRoutes}

          <Redirect to={{
            pathname: ROUTE_PATHS.LOGIN,
            state: {
              from: {
                ...this.props.from,
                // to force the redirect component rendering (even if the 'from' location has not been changed)
                state: { version: Date.now() }
              }
            },
          }}/>
        </Switch>
      </Suspense>
    );
  }
}

export default withRouter(Root);
